var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "toggle-container",
      attrs: { id: "accordion" + _vm.flight.id },
    },
    [
      _c("div", { staticClass: "panel" }, [
        _c(
          "div",
          {
            staticClass: "panel-collapse collapse",
            attrs: { id: "acc" + _vm.flight.id },
          },
          [
            _c(
              "div",
              {
                staticClass: "panel-content",
                staticStyle: { "padding-top": "0px", "padding-left": "15px" },
              },
              [
                _c("hr"),
                _vm._v(" "),
                _c("h4", { staticClass: "box-title" }, [
                  _vm._v(_vm._s(_vm.taxesandfees[_vm.getCurrentLocale]) + ":"),
                ]),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "0px",
                      "padding-right": "10px",
                      "margin-bottom": "0px",
                      width: "50%",
                    },
                  },
                  [
                    _c(
                      "ul",
                      {
                        staticStyle: {
                          "margin-bottom": "0px",
                          "font-size": "0.8333em",
                        },
                      },
                      [
                        _c("li", { staticClass: "skin-color uppercase" }, [
                          _vm._v(
                            _vm._s(_vm.airfare[_vm.getCurrentLocale]) + ": "
                          ),
                          _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("rndAmntRUAFWZ")(
                                  Number(_vm.flight.prcs[0].amnt)
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "skin-color uppercase" }, [
                          _vm._v(
                            _vm._s(_vm.airporttaxes[_vm.getCurrentLocale]) +
                              ": "
                          ),
                          _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("rndAmntRUAFWZ")(
                                  _vm.flight.prcs[0].tax.air
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "skin-color uppercase" }, [
                          _vm._v(
                            _vm._s(_vm.aviationtax[_vm.getCurrentLocale]) + ": "
                          ),
                          _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("rndAmntRUAFWZ")(
                                  _vm.flight.prcs[0].tax.avia
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "skin-color uppercase" }, [
                          _vm._v(
                            _vm._s(
                              _vm.kerosenesurcharge[_vm.getCurrentLocale]
                            ) + ": "
                          ),
                          _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("rndAmntRUAFWZ")(
                                  _vm.flight.prcs[0].tax.fuel
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "skin-color uppercase" }, [
                          _vm._v(
                            _vm._s(_vm.securitycharges[_vm.getCurrentLocale]) +
                              ": "
                          ),
                          _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("rndAmntRUAFWZ")(
                                  _vm.flight.prcs[0].tax.sec
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "skin-color uppercase" }, [
                          _vm._v(
                            _vm._s(_vm.servicecharges[_vm.getCurrentLocale]) +
                              ": "
                          ),
                          _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("rndAmntRUAFWZ")(
                                  _vm.flight.prcs[0].tax.srvc
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }